<label>
  <input #checkbox type="checkbox" class="p-checkbox" [checked]="checked" [disabled]="disabled" (change)="onChangeInput(checkbox)" />
  <span [ngClass]="{ disabled: disabled }"><ng-content> </ng-content></span>
</label>
